exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".-zpDP{background-color:#5d5d5d;position:\"relative\";top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;-ms-flex-pack:center;justify-content:center;color:#fff;-ms-flex-direction:column;flex-direction:column;align-items:center;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif}._1DmgH{font-size:18px;padding-bottom:17px}._2rRg4{font-size:14px}", ""]);

// exports
exports.locals = {
	"overlay": "-zpDP",
	"title": "_1DmgH",
	"text": "_2rRg4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/player-widget/components/new-player/components/not-available-overlay/not-available-overlay.styl
// module id = 1411
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact